// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/less/common.less'
import store from './store/store'
import axios from 'axios'
import VueAxios from 'vue-axios' //异步请求
import VueWechatTitle from 'vue-wechat-title'
import { Loading } from 'element-ui';
import './assets/image/bluerecharge/icon/iconfont.css'

Vue.use(ElementUI)
Vue.use(VueAxios, axios)//全局使用 this.axios
Vue.use(VueWechatTitle)

Vue.config.productionTip = false
axios.defaults.withCredentials = true;//让axios携带cookie
//测试环境
// Vue.prototype.url = 'http://106.15.205.87:8080/'
// 生产地址
// Vue.prototype.url = 'http://106.14.168.179:8089/'
// Vue.prototype.url = 'http://sapi.niceblu.com/'//JAVA
Vue.prototype.url = '/'//JAVA

// Vue.prototype.nodeurl = 'http://nsapi.niceblu.com/'//node
Vue.prototype.nodeurl = '/'//node

//陕西宽带预约
// Vue.prototype.nurl = 'http://napi.js-link.xyz/' //java
Vue.prototype.nurl = '/' //java

// 本地开发
// Vue.prototype.nurl = 'http://test.js-link.xyz/' //java
// Vue.prototype.url = 'http://test.js-link.xyz/'//JAVA

Vue.prototype.$HOST_TLHW = 'https://tlhwapi.niceblu.com' // 陀螺好物API

/**
 * 拉新赚佣路由筛选
 */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  //获取用户登录成功后储存的登录标志
  var isPullNewLogin = localStorage.getItem('isPullNewLogin') ? localStorage.getItem('isPullNewLogin') : store.state.isPullNewLogin;
  console.log(!isPullNewLogin || isPullNewLogin == 'false');
  //根据isLoginNxPullNew字段判断是否路由过滤
  if (to.matched.some(record => record.meta.isLoginNxPullNew)) {
    if (!isPullNewLogin || isPullNewLogin == 'false') {
      if (to.path != '/marketing/nxPullnew/login') {
        return next('/marketing/nxPullnew/login');
      } else {
        next();
      }
    } else {
      if (to.path === '/marketing/nxPullnew/login') {
        return next({ path: '/marketing/nxPullnew/index' });
      } else {
        next();
      }
    }
  } else {
    //若点击的是不需要验证的页面,则进行正常的路由跳转
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Loading,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js